import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import { NumberInput } from 'ui-components/components/number-input';

import { FilterItem } from './filter-item';
import messages from './messages';
import drawerMessages from '../../../messages';

/**
 * BufferStockModifierFilter component that provides a number input for buffer stock modifier
 * @param {object} props - Component props
 * @param {number} props.value - Current value
 * @param {(value: number) => void} props.onChange - Callback function when value changes
 * @returns {JSX.Element} The rendered BufferStockModifierFilter component
 */
export const BufferStockModifierFilter = ({ value, onChange }) => {
  const { formatMessage } = useIntl();

  return (
    <FilterItem
      ariaLabel={formatMessage(messages.bufferStockModifierAriaLabel)}
      inputComponent={<NumberInput max={365} min={0} onChange={onChange} value={value} />}
      label={<FormattedMessage {...drawerMessages.bufferStockModifierLabel} />}
    />
  );
};
